/*
 * PlanWithUs.jsx
 * Created by Destin Frasier on 05/02/18
 */

import React from 'react';

export default class PlanWithUs extends React.Component {
    render() {
        return (
            <ul className="nav-footer-list">
                <li>
                    <a href="/articles">Find Trip Inspiration</a>
                </li>
                <li>
                    <a href="/trips/new">Build a Trip</a>
                </li>
                <li>
                    <a href="/pass/">Buy a Pass</a>
                </li>
                <li>
                    <a href="/lottery/available">Enter a Lottery</a>
                </li>
            </ul>
        );
    }
}
